import { Component, Input } from '@angular/core';
import { AlertService } from '../../shared/utils/alert.service';
import { Alert, AlertType } from '../../models/Alert';
import { JsonPipe, NgIf } from '@angular/common';
@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [NgIf, JsonPipe],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {
  
  @Input() id: string | undefined;
  flashAlert: any = {};
    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getAlert(this.id).subscribe((_alert: Alert) => {
            if (!_alert.message) {
                // clear alerts when an empty alert is received
                this.flashAlert = {};
                return;
            }

            // add alert
            this.flashAlert = _alert;
        });
    }

    removeAlert() {
        this.flashAlert = {};
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success';
            case AlertType.Error:
                return 'alert alert-danger';
            case AlertType.Info:
                return 'alert alert-info';
            case AlertType.Warning:
                return 'alert alert-warning';
        }
    }
}
